/**
 * Bookings domain — admin UI registration (Sub-project III, Task 4).
 *
 * Injects per-record action toolbars into the generic-framework
 * detail pages via the `detailHeader` slot.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import BookingActions from './components/BookingActions.vue';

registerAdminUI('bookings.reservation', {
    slots: {
        detailHeader: BookingActions,
    },
});
